module.exports={render:function (){with(this) {
  return _h('div', [_h('h1', {
    staticClass: "title is-3"
  }, [_h('b', [_s(content.title)]), " ", (content.type === 'pure') ? _h('span', {
    staticClass: "tag is-warning is-medium"
  }, ["Pure"]) : _e(), " ", (content.type === 'impure') ? _h('span', {
    staticClass: "tag is-danger is-medium"
  }, ["Impure"]) : _e()]), " ", _h('p', ["\n    " + _s(content.description) + "\n  "]), " ", _l((examples), function(example) {
    return _h('div', [_h('div', {
      staticClass: "code-container"
    }, [_h('codemirror', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (example.code),
        expression: "example.code"
      }],
      attrs: {
        "options": editorOption
      },
      domProps: {
        "value": (example.code)
      },
      on: {
        "input": function($event) {
          example.code = $event
        }
      }
    }), " ", _h('div', {
      staticClass: "button-group"
    }, [_h('run-button', {
      attrs: {
        "code": example.code,
        "run": run
      }
    })])]), " ", _m(0, true)])
  })])
}},staticRenderFns: [function (){with(this) {
  return _h('br')
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e170780e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topic.vue
// module id = 262
// module chunks = 2